import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const LimitationOfLiability = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            <b>Disclaimer of Warranties.</b> Our website and services are
            provided on an &quot;as is&quot; and &quot;as available&quot; basis
            without any warranties of any kind, either express or implied,
            including but not limited to implied warranties of merchantability,
            fitness for a particular purpose, or non-infringement. Topibro
            Technologies does not warrant that the website will be
            uninterrupted, error-free, or free of viruses or other harmful
            components.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Limitation of Liability.</b> To the fullest extent permitted by
            applicable law, Topibro Technologies shall not be liable for any
            indirect, incidental, special, consequential, or punitive damages
            arising out of or related to your use of, or inability to use, our
            services or website, even if advised of the possibility of such
            damages. Our total aggregate liability to you for any claims arising
            out of or relating to these Terms shall not exceed the amount you
            paid Topibro Tech for the service giving rise to the claim in the
            three (3) months preceding the claim.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Indemnification.</b> You agree to defend, indemnify, and hold
            harmless Topibro Technologies and its officers, directors,
            employees, agents, and partners from and against any claims,
            liabilities, damages, judgments, awards, losses, costs, expenses, or
            fees (including reasonable legal fees) arising out of or relating to
            your violation of these Terms or your use of our services.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Third-Party Links.</b> Our website may contain links to
            third-party websites or services. These links are provided for
            convenience only. Topibro Technologies has no control over and
            assumes no responsibility for the content, privacy policies, or
            practices of any third-party sites. We encourage you to review the
            terms and privacy policies of any third-party sites you visit.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="limitation">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Limitation of Liability
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default LimitationOfLiability;
